// extracted by mini-css-extract-plugin
module.exports = {"bulkAssign":"AssigneeBulkSelect_bulkAssign__2dyzR","loader":"AssigneeBulkSelect_loader__1hchz"};